module.exports = __webpack_public_path__ + "static/img/928_phase_function_Paper_PointsHejduk_Prediction.d46b293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/928_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ++15
// module chunks = 0